import React from "react";
import TextFieldUI, { TextFieldProps } from "@material-ui/core/TextField";

export const TextField = (props: TextFieldProps): React.ReactElement => (
  <TextFieldUI {...props} />
);
